














































































import isMobile from 'piramis-js-utils/lib/isMobile'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

import HelpMessage from '../../../HelpMessage/HelpMessage.vue'
import { SelectOptionData } from '../../../Pi/types'
import PlaceholdersList from '../PlaceholdersList/PlaceholdersList.vue'
import PlaceholdersListMobile from '../PlaceholdersList/PlaceholdersListMobile.vue'
import { ToolBarSettings } from './types'

@Component({
  components: {
    HelpMessage,
    PlaceholdersList,
    PlaceholdersListMobile,
  },
  methods: {
    isMobile,
  },
})
export default class Toolbar extends Vue {
  @Prop({ type: Object }) readonly settings!: ToolBarSettings

  @Prop() setPlaceholder!: (str: string) => void

  @Ref('toolbar') toolbar!: HTMLDivElement

  openPopup = false

  get panelElements(): Array<SelectOptionData> {
    const defaultElem: Array<SelectOptionData> = [
      { value: 'bold', label: this.$t('editor_toolbar_bold_bullet_title').toString() },
      { value: 'italic', label: this.$t('editor_toolbar_italic_bullet_title').toString() },
      { value: 'strike', label: this.$t('editor_toolbar_strike_bullet_title').toString() },
      { value: 'underline', label: this.$t('editor_toolbar_underline_bullet_title').toString() },
      { value: 'code', label: this.$t('editor_toolbar_code_bullet_title').toString() },
      { value: 'tgpre', label: this.$t('editor_toolbar_tgpre_bullet_title').toString() },
      { value: 'link', label: this.$t('editor_toolbar_link_bullet_title').toString() },
      { value: 'tgspoiler', label: this.$t('editor_toolbar_tgspoiler_bullet_title').toString() },
      // { value: 'blockquote', label: this.$t('editor_toolbar_blockquote_bullet_title').toString() },
      // { value: 'blockquoteExpandable', label: this.$t('editor_toolbar_blockquote_expand_bullet_title').toString() },
      { value: 'clean', label: this.$t('editor_toolbar_clean_bullet_title').toString() },
      { value: 'emoji', label: this.$t('editor_toolbar_emoji_bullet_title').toString() },
    ]
    const arr: Array<SelectOptionData> = []

    if (this.settings.disabledPanelElements && this.settings.disabledPanelElements.length) {
      for (const elem of defaultElem) {
        if (!this.settings.disabledPanelElements.includes(elem.value)) {
          arr.push(elem)
        }
      }
      return arr
    }
    return defaultElem
  }

  get fullscreenHandler(): () => void | undefined {
    return this.settings.fullscreen.toggle
  }

  get isFullscreen(): boolean {
    return this.settings.fullscreen.isFullscreen()
  }

  toolbarWheel(event: WheelEvent): void {
    this.toolbar.scroll({ behavior: 'smooth', left: this.toolbar.scrollLeft + event.deltaY })
    event.stopPropagation()
    event.preventDefault()
  }
}
